<template>
  <div
    :id="slug"
    class="card px-4 py-2 lg:px-12 lg:py-8 my-12"
  >
    <router-link :to="`${$route.path}#${slug}`">
      <VinTitle :text="$t(slug)" />
    </router-link>
    <hr class="my-5">
    <div
      v-html="markup"
    />
  </div>
</template>

<script>
export default {
  name: 'TermCard',
  props: {
    slug: {
      type: String,
      default: 'Terms of Service',
    },
    vid: {
      type: String,
      default: null,
    },
    markup: {
      type: String,
      default: '',
    },
  },
}
</script>
